<template>
	<div class="site-not-available-wrapper">
		<div class="fotex-image-background"><img :src="getMiscImageUrl('mobileTopImage.jpg')" /></div>
		<div class="fotex-logo-disable-page"><img src="~@static/tid3/images/logo_fotex_mad_ud_af_huset.svg"/></div>
		<div class="fotex">
			<div class="bil-brocken sm-brocken fo-brocken">
				Websitet er midlertidigt ikke tilgængeligt
			</div>
			<div class="bil-brocken-sub sm-brocken-sub fo-brocken-sub">
				<template v-if="platform === ''">
					{{tenantSettings.tenantUnavailableCustomText ? tenantSettings.tenantUnavailableCustomText : "Vi er i gang med at opdatere systemet, men er snart færdige. Vi beklager ulejligheden."}}
				</template>
				<template v-else-if="platform === 'android'">
					{{tenantSettings.tenantUnavailableCustomTextAndroid ? tenantSettings.tenantUnavailableCustomTextAndroid : "Vi er i gang med at opdatere systemet, men er snart færdige. Vi beklager ulejligheden."}}
				</template>
				<template v-else-if="platform === 'ios'">
					{{tenantSettings.tenantUnavailableCustomTextIos ? tenantSettings.tenantUnavailableCustomTextIos : "Vi er i gang med at opdatere systemet, men er snart færdige. Vi beklager ulejligheden."}}
				</template>
			</div>
			<div class="center-button-align"><v-btn @click="siteNotAvailableRedirect" flat class="fotex-btn">Gå til føtex.dk</v-btn></div>
		</div>
		<div class="fotex-bottom">tilgængeligt</div>
	</div>
</template>

<script>
	import * as Utils from "../../../../libraries/utils";
	import {mapGetters} from "vuex";
	export default {
		name: "SiteNotAvailableTid3",
		props: ["siteNotAvailableRedirect", "platform"],
		methods: {
			getMiscImageUrl: Utils.getMiscImageUrl
		},
		computed: {
			...mapGetters(["tenantSettings"])
		}
	};
</script>

<style scoped>
	.site-not-available-wrapper {
		padding-top: 4em;
	}
</style>
